import { clsObj } from "client-util/util";
import { PuzzleLink } from "components/Link";
import { PuzzleContentPreview } from "components/PuzzleContent/PuzzleContentPreview";
import { memo } from "react";
import Twemoji from "react-twemoji";
import { UNTITLED_PUZZLE_DISPLAY_NAME } from "sockapi/puzzle-data";
import { useInPuzzlePage } from "stores/NavStore";
import { shallow as shallowEqual } from "zustand/vanilla/shallow";
import "./PuzzleCard.css";

export type PuzzleCardProps = {
  preview?: boolean;
  puzName: string;
  displayName: string;
  hasHints: boolean;
  isActive: boolean;
  isNew: boolean;
  onClick: () => void;
};

function PuzzleCard({
  preview,
  puzName,
  displayName,
  isActive,
  isNew,
  onClick,
}: PuzzleCardProps) {
  const { inPuzzle } = useInPuzzlePage();
  const displayDisplayName = (() => {
    if (!displayName.includes(UNTITLED_PUZZLE_DISPLAY_NAME)) return displayName;
    const [before, after] = displayName.split(UNTITLED_PUZZLE_DISPLAY_NAME);
    return (
      <>
        {before}
        <span className="puzzle-card-untitled">
          {UNTITLED_PUZZLE_DISPLAY_NAME}
        </span>
        {after}
      </>
    );
  })();

  const internal = (
    <>
      <div className="puzzle-card-decoration" />
      <div
        className={`puzzle-card-title ${displayName === "" ? "centered" : ""}`}
      >
        <span className="puzzle-card-icons">
          {isNew ? <Twemoji>🆕</Twemoji> : null}
        </span>
        <h3 title={displayName}>{displayDisplayName}</h3>
      </div>
      <div className="puzzle-card-preview">
        {preview && (
          <PuzzleContentPreview
            puzName={puzName}
            style={{ border: "none", height: "3.5em" }}
          />
        )}
      </div>
    </>
  );

  return inPuzzle ? (
    <div
      className={clsObj({
        "puzzle-card": true,
        active: isActive,
      })}
      onClick={onClick}
    >
      {internal}
    </div>
  ) : (
    <PuzzleLink subpage="piece" puzName={puzName}>
      <div className={clsObj({ "puzzle-card": true, active: isActive })}>
        {internal}
      </div>
    </PuzzleLink>
  );
}

export default memo(PuzzleCard, shallowEqual);
